import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const AppPoweredTaskSectionLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-apppoweredtasksection" */ "./AppPoweredTaskSection")).then((bundle)=>{
        return {
            default: bundle.AppPoweredTaskSection
        };
    });
export const LazyAppPoweredTaskSection = /*#__PURE__*/ lazy(AppPoweredTaskSectionLazyLoader);
